import moment from 'moment'
/* Transient State: wird nicht persistiert */
const transientState = {

	state: () => ({
		mobileAppsMode: false,
		restoreFactorySettings: false,
		loading: false,
		loadingSubject: '',
		displayMomentValueOf: moment().valueOf(),
		scrollPosition: 0,
		scrollDirectionUp: true,
	}),

	getters:{
		displayMoment: state => moment(state.displayMomentValueOf),
		isMobileAppMode: state => state.mobileAppsMode,
		isLoading: state => state.loading,
		loadingSubject: state => state.loadingSubject,
		scrollDirectionUp: state => state.scrollDirectionUp,
		scrollPosition: state => state.scrollPosition
	},

	mutations: {
		restoreFactorySettings: (state) => { state.restoreFactorySettings = true },
		scrollPosition: (state, payload) => { 
			state.scrollDirectionUp = state.scrollPosition > payload 
			state.scrollPosition = payload
		},
		displayMoment (state, payload = moment()) { state.displayMomentValueOf = payload.valueOf() },
		setupAppRuntimeSettings: (state) => {
			state.mobileAppsMode = window.cordova?true:false
			state.credentialsSupported = 'credentials' in navigator
		},
		setLoading(state, payload) { state.loading = payload?true:false} ,
		setLoadingWithSubject: (state, payload) => { 
			if(!state.loading) state.loading = true
			state.loadingSubject = payload
		},
		loadCompleted: (state) => { state.loading = false },
	},
	actions: {
		test: (ctx) => console.log('transientState - action'),
	}
}
export default transientState